import react from 'react';
import { Text, Image } from '@chakra-ui/react';
import logo from './assets/image/logo.png';
import { FaStore, FaTwitter,FaDiscord,FaEthereum } from "react-icons/fa";
import './new.css'
import image1 from './assets/image/1234.jpg';


export function HeaderX () {
    return(
        <div>
            <center>
                {/* <Image
                    borderRadius='20px'
                    border="2px solid"
                    boxSize='150px'
                    mb="30px"
                    src={image1}
                /> 

            <Text
                fontSize="56px"
                color="white"
                fontWeight="800"
                mb="20px"
            >CutieCats Club</Text> */}


                <div className="iconZone">
                    <a href='https://twitter.com/lex101labs' target="_blank">
                        <FaTwitter color="white" fontSize="25px"/>
                    </a>
                    <a href='https://discord.gg/lex101labs' target="_blank">
                        <FaDiscord color="white" fontSize="25px"/>
                    </a>
                    <a href='https://nova.arbiscan.io/address/0x1f9cA631AE0C4890F99b38634C969b7E4f8719F0#writeContract' target="_blank">
                        <FaEthereum color="white" fontSize="25px"/>
                    </a>
                    <a href='https://opensea.io/collection/novapepelabs' target="_blank">
                        <FaStore color="white" fontSize="25px"/>
                    </a>
                </div>
            </center>
            


      
    </div>

    )

}